module.exports = __webpack_public_path__ + "static/img/head-pt.2731a884.png";